const PLAID_API_PATHS = {
    ROOT: '/plaid-api',

    CREATE_LINK_TOKEN() {
        return `${this.ROOT}/create_link_token`
    },
    EXCHANGE_PUBLIC_TOKEN() {
        return `${this.ROOT}/exchange_public_token`
    },
    GET_ACCOUNTS() {
        return `${this.ROOT}/get_accounts`
    },
    GET_ACCOUNT_BALANCES() {
        return `${this.ROOT}/accounts/balance/get`
    },
    GET_TRANSACTIONS() {
        return `${this.ROOT}/get_transactions`
    },
    GET_LIABILITIES() {
        return `${this.ROOT}/get_liabilities`
    },
    GET_INSTITUTION_BY_ID() {
        return `${this.ROOT}/get_institution_by_id`
    }
}

export default PLAID_API_PATHS
